/**
 * Free Gift With Every Order
 * ---------------------------------------------------------------------
 * Reads window.freeGiftSettings (set by layout/theme.liquid via the
 * "Free Gift" theme settings) and makes sure exactly 1 unit of that
 * product is in the cart whenever the cart has at least one other
 * (real) product in it. If the shopper removes it, it is silently
 * re-added - the gift is "locked" to the order.
 *
 * This script does NOT make the item free by itself. Create a "Buy X
 * Get Y" automatic discount in Shopify Admin that gives this product
 * free, or price the gift variant at 0.
 * ---------------------------------------------------------------------
 */
(function () {
  var settings = window.freeGiftSettings;
  if (!settings || !settings.enabled || !settings.variantId) return;

  var GIFT_VARIANT_ID = Number(settings.variantId);
  var isChecking = false;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { _free_gift: 'yes' }
          }
        ]
      })
    });
  }

  function setLineQuantity(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  // Refresh the visible cart drawer + header cart bubble via Shopify's
  // Section Rendering API instead of reloading the whole page.
  function fetchSectionHTML(sectionId) {
    return fetch('/?section_id=' + sectionId).then(function (r) { return r.text(); });
  }

  function refreshCartUI() {
    return Promise.all([fetchSectionHTML('cart-drawer'), fetchSectionHTML('header')])
      .then(function (results) {
        var parser = new DOMParser();

        var drawerDoc = parser.parseFromString(results[0], 'text/html');
        var newItems = drawerDoc.getElementById('CartDrawer-CartItems');
        var oldItems = document.getElementById('CartDrawer-CartItems');
        var newFooter = drawerDoc.querySelector('.cart-drawer__footer');
        var oldFooter = document.querySelector('.cart-drawer__footer');
        var newDrawerRoot = drawerDoc.querySelector('cart-drawer');
        var oldDrawerRoot = document.querySelector('cart-drawer');

        if (!newItems || !oldItems) {
          // Markup didn't match what we expected (e.g. cart_type isn't
          // "drawer") - fall back to a full reload so the UI is never wrong.
          window.location.reload();
          return;
        }

        oldItems.innerHTML = newItems.innerHTML;
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
        if (newDrawerRoot && oldDrawerRoot) {
          oldDrawerRoot.classList.toggle('is-empty', newDrawerRoot.classList.contains('is-empty'));
        }

        var headerDoc = parser.parseFromString(results[1], 'text/html');
        var newBubble = headerDoc.getElementById('cart-icon-bubble');
        var oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
      })
      .catch(function () {
        // Any unexpected failure - fall back to a full reload rather than
        // leaving the cart UI out of sync.
        window.location.reload();
      });
  }

  function ensureGift() {
    if (isChecking) return;
    isChecking = true;

    getCart()
      .then(function (cart) {
        var giftLine = null;
        var hasOtherItems = false;

        cart.items.forEach(function (item) {
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftLine = item;
          } else {
            hasOtherItems = true;
          }
        });

        // Cart is empty of real products (or has only the gift) - don't
        // let the gift sit in an otherwise-empty cart by itself.
        if (!hasOtherItems) {
          if (giftLine) {
            return setLineQuantity(giftLine.key, 0).then(refreshCartUI);
          }
          return;
        }

        // Gift is missing - add it back and refresh the cart UI in place.
        if (!giftLine) {
          return addGift().then(refreshCartUI);
        }

        // Someone changed the quantity - lock it back to 1.
        if (giftLine.quantity !== 1) {
          return setLineQuantity(giftLine.key, 1).then(refreshCartUI);
        }
      })
      .catch(function (err) {
        console.error('[Free Gift] check failed:', err);
      })
      .finally(function () {
        isChecking = false;
      });
  }

  // Re-run the check any time the theme's own cart AJAX calls happen
  // (add to cart, quantity change, drawer update, etc).
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] instanceof Request ? args[0].url : args[0];
    var isCartMutation =
      typeof url === 'string' &&
      /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);

    var result = nativeFetch.apply(this, args);

    if (isCartMutation) {
      result.then(function () {
        setTimeout(ensureGift, 250);
      });
    }

    return result;
  };

  // Also check on every normal page load (covers direct visits to /cart,
  // back/forward navigation, etc).
  document.addEventListener('DOMContentLoaded', ensureGift);
})();
